/** Coerce API/persisted values into a string array (avoids `.length` on undefined). */
export function asStringArray(value: unknown): string[] {
  if (value == null) return [];
  if (Array.isArray(value)) {
    return value.filter((x): x is string => typeof x === 'string' && x.length > 0);
  }
  if (typeof value === 'string' && value.trim()) return [value.trim()];
  return [];
}
